import { dynamicImport } from '@core/helpers'
import { ROUTES } from '@router'

export default () => {
  return [
    {
      path: '/credit-card/update',
      name: ROUTES.CREDIT_CARD.UPDATE,
      component: () => dynamicImport(import('./pages/CreditCardUpdatePage')),
      meta: {
        auth: {
          required: true,
        },
      },
    },
    {
      path: '/credit-card/update/success',
      name: ROUTES.CREDIT_CARD.UPDATE_SUCCESS,
      component: () =>
        dynamicImport(import('./pages/CreditCardUpdateSuccessPage')),
    },
    {
      path: '/credit-card/update/failure',
      name: ROUTES.CREDIT_CARD.UPDATE_FAILURE,
      component: () =>
        dynamicImport(import('./pages/CreditCardUpdateFailurePage')),
    },
  ]
}
